const plans = {
  TRIAL: 1,
  BASIC: 2,
  CLASSIC: 3,
  BLACK: 4,
  TMD: 5,
}

export default plans
